import { Lookup } from '../../../shared/model/lookup';

export class DebtorType extends Lookup {
  constructor(code: string, name: string) {
    super(code, name);
  }
}
